import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFText,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerbg, logo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView>
          {/* <CFView row center>
            <CFImage h="40px" src={logo} alt="Masita Korean Cuisine" />
            <CFImage
              h="20px"
              ml="12px"
              src={logoTitle}
              alt="Gates Park Cafe Restaurant Logo Title"
            />
          </CFView> */}
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          zIndex={98}
          row
          justifyStart
          w="100%"
          maxWidth="1400px"
          bg="black"
          pv="8px"
        >
          <CFView h2 white xBold ml="35px" mt="3px">
            GATES PARK CAFE
          </CFView>
          <CFView
            center
            br="20px"
            bc="white"
            bw="3px"
            pv="3px"
            ph="8px"
            hover
            zIndex={99}
            white
            xBold
            ml="15px"
          >
            PORT COQUITLAM
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
